import { jsonify, sanitize } from "../generated/TapiocaUtils";
/**
 * Client for calling Customer API in "admin protected" mode
 */
export default class InternalCapiClient {
  constructor(raw) {
    this.raw = raw;
  }
  /** Create an OAuth access token for a given user without their intervention. */
  createOauthAccessToken(body) {
    return this.raw.post("/oauth/gifted_tokens", jsonify(body));
  }
  /** Get a list of filtered photo assets for a project. */
  getPhotoAssetListFilter(projectUid, body, params) {
    const url = {
      url: `/projects/${projectUid}/photos/assets/filter`,
      params: sanitize(params),
    };
    return this.raw.post(url, jsonify(body));
  }
  /** Get a list of filtered sheet assets for a project. */
  getSheetAssetListFilter(projectUid, body, params) {
    const url = {
      url: `/projects/${projectUid}/sheets/assets/filter`,
      params: sanitize(params),
    };
    return this.raw.post(url, jsonify(body));
  }
  /** Get a list of filtered snapshot assets for a project. */
  getSnapshptAssetListFilter(projectUid, body, params) {
    const url = {
      url: `/projects/${projectUid}/snapshots/assets/filter`,
      params: sanitize(params),
    };
    return this.raw.post(url, jsonify(body));
  }
  /** Returns a user on a project team with its assets. */
  getProjectUserAssets(projectUid, userUid, params) {
    const url = {
      url: `/projects/${projectUid}/users/${userUid}/assets`,
      params: sanitize(params),
    };
    return this.raw.get(url);
  }
}
